import { Injectable } from '@angular/core';
import { WsService } from './ws.service';
import { StateService } from './state.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class SettingsService {

    reqSub;
    rawOrders = [];
    taxiServices: any;

    public settings = {};
    currentSettings: BehaviorSubject<any>;
    public products = new BehaviorSubject({});
    public operatorSettings = new BehaviorSubject({});
    currentServiceId: number;

    constructor(private ws: WsService,
        private state: StateService) {
        this.currentSettings = new BehaviorSubject(null);
        this.currentSettings.subscribe(service_id => {
            this.currentServiceId = service_id;
        });
    }

    createSubscription() {
        this.listen();
        this.state.getParameter('services').subscribe(res => {
            this.taxiServices = res;
            this.taxiServices.map(service => {
                this.ws.send({
                    'header': {
                        'type': 'sub',
                        'action': 'set'
                    },
                    'data': {
                        'subscriptions': [
                            'sets'
                        ],
                        'arguments': {
                            'sets': {
                                'service_id': service.id,
                                'reuse': false
                            }
                        }
                    }
                });
            });
        });
    }

    public setCurrentServiceId(service_id) {
        this.currentServiceId = service_id;
    }

    private convert(service, array) {
        let newSettting = {};
        if (array)
            array.forEach(el => {
                newSettting[el.key] = el.value;
            });
        this.settings[service] = { ...this.settings[service], ...newSettting };
    }

    private listen() {
        this.reqSub = this.ws.message.subscribe(
            (msg) => {
                let res = JSON.parse(msg);
                if (res.header.type === 'sets') {
                    switch (res.header.action) {
                        case 'rcv':
                            let prod = this.products;
                            prod[res.data.service_id] = res.data.products;
                            this.products.next(prod);

                            let osets = this.operatorSettings;
                            osets[res.data.service_id] = res.data.settings;
                            this.operatorSettings.next(osets);
                            this.convert(res.data.service_id, res.data.settings);
                            break;
                        case 'create':
                            if (res.header.data_id == 'product') {
                                let products = this.products;
                                products[res.data.product.service_id] = [...products[res.data.product.service_id], res.data.product];
                                this.products.next(products);
                            }
                            break;
                        case 'delete':
                            if (res.header.data_id == 'product') {
                                let prods = this.products;
                                const index = prods[res.data.product.service_id].findIndex(product => product.id == res.data.product.id);
                                if (index > -1) {
                                    prods[res.data.product.service_id].splice(index, 1);
                                }
                                this.products.next(prods);
                            }
                            break;
                        case 'update':
                            if (res.header.data_id == 'settings') {
                                let sets = this.operatorSettings;
                                let newSets = sets[res.data.service_id].map(setting => {
                                    if (setting.key == res.data.key) {
                                        setting.value = res.data.value;
                                    }
                                    return setting;
                                });
                                sets[res.data.service_id] = newSets;
                                this.operatorSettings.next(sets);
                                this.convert(res.data.service_id, res.data.settings);
                            }
                            if (res.header.data_id == 'product') {

                                let prods = this.products;
                                let newProds = prods[res.data.product.service_id].map(product => {
                                    if (product.id == res.data.product.id) {
                                        product = res.data.product;
                                    }
                                    return product;
                                });
                                prods[res.data.product.service_id] = newProds;
                                this.products.next(prods);
                            }
                    }
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/settings.service.ts